const preference=matchMedia('(prefers-reduced-motion: reduce)');
const root=document.documentElement,button=document.querySelector('[data-motion-toggle]');
let paused=false,observer;
const animations=new Set();
try{paused=sessionStorage.getItem('one-step-motion')==='paused';}catch(error){/* Optional preference. */}
const animate=(element,frames,options)=>{
 const animation=element.animate(frames,options);animations.add(animation);
 animation.finished.catch(()=>{}).finally(()=>animations.delete(animation));
};
const setup=()=>{
 observer?.disconnect();animations.forEach(animation=>animation.cancel());animations.clear();
 const inactive=paused||preference.matches;
 root.classList.toggle('motion-paused',inactive);
 if(button){const label=preference.matches?'Bewegung durch Geräteeinstellung reduziert':inactive?button.dataset.playLabel:button.dataset.pauseLabel;button.disabled=preference.matches;button.setAttribute('aria-label',label);button.title=label;button.setAttribute('aria-pressed',String(inactive));button.firstElementChild.textContent=inactive?'▷':'Ⅱ';}
 dispatchEvent(new CustomEvent('onestep:motion',{detail:{paused:inactive}}));
 if(inactive)return;
 observer=new IntersectionObserver(entries=>entries.forEach(entry=>{
  if(!entry.isIntersecting)return;
  const heading=/^H[1-6]$/.test(entry.target.tagName);
  animate(entry.target,[{opacity:0,transform:`translateY(${heading?42:24}px)`,clipPath:'inset(0 0 35% 0)'},{opacity:1,transform:'none',clipPath:'inset(0)'}],{duration:heading?1000:750,easing:'cubic-bezier(.16,1,.3,1)'});
  observer.unobserve(entry.target);
 }),{threshold:.08});
 document.querySelectorAll('.reveal').forEach(element=>observer.observe(element));
 document.querySelectorAll('.one-hero__title > span:not(.sr-only),.one-hero__title > em').forEach((element,i)=>animate(element,[{transform:'translateY(24px)',opacity:0},{transform:'none',opacity:1}],{duration:1000,delay:80+i*90,easing:'cubic-bezier(.16,1,.3,1)',fill:'backwards'}));
};
button?.addEventListener('click',()=>{if(preference.matches)return;paused=!paused;try{sessionStorage.setItem('one-step-motion',paused?'paused':'active');}catch(error){/* Optional preference. */}setup();});
preference.addEventListener('change',setup);
setup();
const progress=document.querySelector('.scroll-progress span');
let frame=0;
const update=()=>{frame=0;const length=document.documentElement.scrollHeight-innerHeight;if(progress)progress.style.transform=`scaleX(${length>0?scrollY/length:0})`;};
addEventListener('scroll',()=>{if(!frame)frame=requestAnimationFrame(update);},{passive:true});
update();
